import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'app/shared/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CertificateSelectComponent} from './components/certificate-select.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule
    ],
    declarations: [
        CertificateSelectComponent
    ],
    exports: [
        CertificateSelectComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
})
export class CertificateSelectModule {
}



// WEBPACK FOOTER //
// ./src/app/common/certificate-select/certificate-select.module.ts